<template>
  <div>
    <div class="card-general-container">
      <div class="m-3">
        <img
          src="/img/sureload.png"
          class="overlay-logo-end sure-load-temp-styling"
          alt="logo"
        />
        <img src="/img/bgcard.jpg" class="overlay-logo-bg" alt="logo" />
        <div class="row card-general-upper" >
          <div class="col">
            <div>
              <div class="d-flex align-items-center">
                <h6 class="mb-0 upper-text-light">General Balance</h6>
                <img
                  src="/img/eye.png"
                  alt="logo"
                  class="ms-3"
                  style="height: 1em"
                />
              </div>

              <div class="d-flex align-items-center">
                <div class="">
                  <h2
                    class="mb-0 upper-text-light fw-bold d-flex align-items-center"
                  >
                    <div class="currency me-2">PHP</div>
                    {{ formattedGeneralBalance }}
                  </h2>
                </div>
                <!-- <div class="ms-5">
                  <h6 class="mb-0 upper-text-light">
                    Earmarked : {{ this.masterDealer.earmarked }}
                  </h6>
                </div> -->
              </div>
            </div>

            <hr class="horizontal light" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="d-flex flex-wrap">
              <div class="card-new">
                <div class="upper-section">
                  <img src="/img/masterdealer.png" alt="logo" />
                  <div class="d-flex">
                    <div
                      class="icon-container"
                      @click="selectTransaction('SMART')"
                    >
                      <img src="/img/transaction.png" alt="logo" />
                    </div>
                    <!-- <div class="icon-container">
                      <img src="/img/update.png" alt="logo" />
                    </div> -->
                  </div>
                </div>
                <div class="body-section">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="mb-0 p-0 value">Smart</p>
                      <hr class="bg-dark w-100" />
                    </div>
                    <div class="text-end">
                      <h6 class="mb-0 card-text-dark">
                        <template v-if="masterloading">
                          <p class="placeholder-glow mb-0">
                            <span class="placeholder col-12"></span>
                          </p>
                        </template>
                        <template v-else>
                          {{ formattedBalance }}
                        </template>
                      </h6>
                      <small class="text-muted">Wallet Balance</small>
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-content-between">
                    <p class="mb-0 p-0"></p>
                    <p class="mb-0 p-0">
                      Earmarked :
                      <span class="card-text-dark"
                        >{{ formattedEarmarkedBalance }}</span
                      >
                    </p>
                  </div> -->
                </div>
              </div>
              <div class="card-new">
                <div class="upper-section">
                  <img src="/img/bayad_logo.png" alt="logo" />
                  <div class="d-flex">
                    <div
                      class="icon-container"
                      @click="selectTransaction('BAYAD')"
                    >
                      <img src="/img/transaction.png" alt="logo" />
                    </div>
                    <!-- <div class="icon-container">
                      <img src="/img/update.png" alt="logo" />
                    </div> -->
                  </div>
                </div>
                <div class="body-section">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="mb-0 p-0 value">Bayad Biller</p>
                      <hr class="bg-dark w-100" />
                    </div>
                    <div class="text-end">
                      <h6 class="mb-0 card-text-dark">
                        <template v-if="masterloading">
                          <p class="placeholder-glow mb-0">
                            <span class="placeholder col-12"></span>
                          </p>
                        </template>
                        <template v-else>
                          {{ formattedBayadBalance }}
                        </template>
                      </h6>
                      <small class="text-muted">Wallet Balance</small>
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-content-between">
                    <p class="mb-0 p-0">WEE000000000071403</p>
                    <p class="mb-0 p-0">
                      Earmarked : <span class="card-text-dark">12,930.78</span>
                    </p>
                  </div>
                  <p class="mb-0 p-0">WEECENT</p>
                  <p class="mb-0 p-0">W3eC3nTU$er</p> -->
                </div>
              </div>
              <!-- <div class="card-new">
                            <div class="upper-section">
                                <img src="/img/bayad_logo.png" alt="logo" />
                                <div class="d-flex">
                                    <div class="icon-container">
                                        <img src="/img/transaction.png" alt="logo" />
                                    </div>
                                    <div class="icon-container">
                                        <img src="/img/update.png" alt="logo" />
                                    </div>
                                </div>
                            </div>
                            <div class="body-section">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p class="mb-0 p-0 value">Bayad Loading</p>
                                        <hr class="bg-dark w-100" />
                                    </div>
                                    <div class="text-end">
                                        <h6 class="mb-0 card-text-dark">P 1,000,000.00</h6>
                                        <small class="text-muted">Wallet Balance</small>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <p class="mb-0 p-0">WEE000000000071403</p>
                                    <p class="mb-0 p-0">Earmarked : <span class="card-text-dark">12,930.78</span></p>
                                </div>
                                <p class="mb-0 p-0">WEECENT</p>
                                <p class="mb-0 p-0">W3eC3nTU$er</p>

                            </div>
                        </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../../assets/no-data.json";
import searchingJSON from "./../../../../assets/searching.json";

export default {
  data() {
    return {
      noDataJSON,
      searchingJSON,
    };
  },
  computed: {
    ...mapState({
      masterDealerLoading: (state) =>
        state.retailerController.masterDealerLoading,
      balance: (state) => state.retailerController.smartBalance,
      bayadBalance: (state) => state.billerController.bayadBalance,
      masterDealer: (state) => state.retailerController.filteredMasterDealer,
      masterloading: (state) => state.retailerController.masterDealerLoading,
    }),
    formattedBalance() {
      const amount = this.masterDealer.smartBalance ?? 0;
      return amount.toLocaleString("en-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits: 2,
      });
    },
    formattedBayadBalance() {
      const amount = this.masterDealer.bayadBalance ?? 0;
      return amount.toLocaleString("en-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits: 2,
      });
    },

    formattedEarmarkedBalance() {
      const amount = this.masterDealer.earmarked ?? 0;
      return amount.toLocaleString("en-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits: 2,
      });
    },
    generalBalance() {
      const smart = Number(this.masterDealer.smartBalance ?? 0);
      const bayad = Number(this.masterDealer.bayadBalance ?? 0);
      return smart + bayad;
    },

    formattedGeneralBalance() {
      return this.generalBalance.toLocaleString("en-PH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  methods: {
    ...mapActions({
      getSmartBalance: "retailerController/GetSmartBalance",
      getBayadBalance: "billerController/GetBayadBalance",
      getMasterDealer: "retailerController/GetMasterDealer",
    }),
    ...mapMutations({
      selectRetailer: "retailerController/SELECT_Retailer",
      toggleShowRetailerSidebar:
        "retailerController/TOGGLE_ShowRetailerSidebar",
    }),
    topUpRetailer(retailer) {
      alert("not yet implemented.");
      // this.selectRetailer(retailer);
      // this.toggleShowTopUpRetailerSidebar(true);
    },
    editRetailer(retailer) {
      this.selectRetailer(retailer);
      this.toggleShowRetailerSidebar(true);
    },
    selectTransaction(type) {
      this.$emit("transaction-selected", type);

      console.log("type:", type);
    },
  },
  async mounted() {
    this.getSmartBalance().catch((err) => {
      console.error("Failed to get Smart Balance", err);
    });

    this.getBayadBalance().catch((err) => {
      console.error("Failed to get Bayad Balance", err);
    });
    await this.getMasterDealer();
  },
};
</script>

<style scoped>
/*remmove once we return Balance from Bayad*/
/* .sure-load-temp-styling {
  width: 30%;
  height: 211px;
} */
</style>
